import Head from "next/head";
import PagePrivacyPolicy from "../components/pages/PagePrivacy";

const PAGE_TITLE = "Privacy | Gridley";

export default function SSG() {
  return (
    <>
      <Head>
        <title>{PAGE_TITLE}</title>
        <meta name="title" content={PAGE_TITLE} />
      </Head>
      <PagePrivacyPolicy />
    </>
  );
}
